function safeStorage() {
    try {
        if (typeof window === 'undefined' || !window.localStorage) return null;
        return window.localStorage;
    } catch {
        return null;
    }
}

export function getStoredItem(key, fallback = null) {
    const storage = safeStorage();
    if (!storage) return fallback;
    const value = storage.getItem(key);
    return value ?? fallback;
}

export function setStoredItem(key, value) {
    const storage = safeStorage();
    if (!storage) return;
    storage.setItem(key, value);
}

export function removeStoredItem(key) {
    const storage = safeStorage();
    if (!storage) return;
    storage.removeItem(key);
}
